var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding":"0"}},[_c('iframe',{attrs:{"width":"100%","height":"480","src":'https://www.youtube.com/embed/' + _vm.obj.task.taskDesc.split('=')[1],"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }